import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MainComponent } from '../layouts/main/main.component';
import { routePaths } from '../app-route-paths';
import { AsideLink } from '../layouts/aside/aside.component';

const featuresRoutes = routePaths.features.children;

/** Features component. */
@Component({
  selector: 'sa-features',
  imports: [MainComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css'],
})
export class FeaturesComponent {
  /** Links. */
  protected readonly links: readonly AsideLink[] = [
    { path: featuresRoutes.socialAuth.url, title: 'Authentication' },
    { path: featuresRoutes.filters.url, title: 'Filters' },
    { path: featuresRoutes.codegen.url, title: 'Codegen' },
    { path: featuresRoutes.payment.url, title: 'Stripe Payment' },
    { path: featuresRoutes.uploadFiles.url, title: 'Upload Files' },
    { path: featuresRoutes.chats.url, title: 'Chats' },
  ];
}
